import '/@front:css/style.css'

import { initializeBase } from './shared/base'

initializeBase()
